/*
Author: Liubo
Date: 2018-11-27
Desc: 框架和项目公用方法
*/
import util from "./util";
import utilJfit from "./util_jfit";
import cache from "@/assets/js/cache";
import format from "date-fns/format";
export default Object.assign(util, utilJfit);

// 是否查询全部基金（过滤风险等级不符的基金）
export function getRiskFilter() {
    const userInfo = cache.getUser();
    if (isValidProfessionalInvestor()) {
        return "0";
    }
    if (userInfo.qryallfund) {
        return userInfo.qryallfund == "0" ? "1" : "0";
    }
    return "1";
}

/** 是否为有效专业投资者：专业投资者且资格有效期未过期（可查全部基金/不做风险过滤） */
export function isValidProfessionalInvestor() {
    const info = cache.getUser();
    const todayStr = format(new Date(), "YYYYMMDD");
    const effect = info.effectdate;
    return info.professionflag === "1" && effect && effect >= todayStr;
}

